export const IS_ONBOARDED = 'IS_ONBOARDED'
export const SYSTEM_NOTIFICATIONS = 'SYSTEM_NOTIFICATIONS'



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/store/modules/onboarding/types.js
// module id = null
// module chunks = 